/**
 * 채용 트랙·공고 — 운영 시 이 파일을 수정하면 채용·채용공고 페이지에 반영됩니다.
 */

export const RECRUIT_TRACKS = [
    {
        track: '소프트웨어 엔지니어링',
        roles: ['백엔드·플랫폼', '프런트엔드', '모바일', '데브옵스·인프라'],
        note: '경력 연차에 맞는 과제·면접 단계로 진행합니다.',
    },
    {
        track: '프로덕트·디자인',
        roles: ['프로덕트 매니저', 'UX·UI 디자인'],
        note: '서비스 기획 경험과 포트폴리오를 함께 검토합니다.',
    },
    {
        track: '비즈니스',
        roles: ['기술 세일즈', '컨설팅'],
        note: '정보기술 이해도와 고객 커뮤니케이션 역량을 중시합니다.',
    },
]

/**
 * @typedef {Object} JobPosting
 * @property {string} id
 * @property {string} title
 * @property {string} track
 * @property {string} employment
 * @property {string} experience
 * @property {string} location
 * @property {'모집 중' | '마감' | '예정'} status
 * @property {string} summary
 * @property {string} [postedAt]
 */

/** 개별 공고 목록 (예시 — 실제 공고로 교체·추가하세요) */
export const JOB_POSTINGS = [
    {
        id: 'be-spring-2026',
        title: '백엔드 개발자 (Java·Spring·클라우드)',
        track: '소프트웨어 엔지니어링',
        employment: '정규직',
        experience: '경력 4년 이상',
        location: '서울 (혼합 근무)',
        status: '모집 중',
        postedAt: '2026-05-01',
        summary:
            'B2B 플랫폼·연동 API·운영 자동화를 함께 다룰 분을 찾습니다. 가용성·보안·관측성을 염두에 둔 설계 경험이 있으면 좋습니다.',
    },
    {
        id: 'fe-react-2026',
        title: '프런트엔드 개발자 (React·TypeScript)',
        track: '소프트웨어 엔지니어링',
        employment: '정규직',
        experience: '경력 3년 이상',
        location: '서울 (혼합 근무)',
        status: '모집 중',
        postedAt: '2026-05-01',
        summary:
            '대규모 웹 애플리케이션의 화면·상태·성능을 책임질 분을 모집합니다. 디자인 시스템·접근성에 관심이 있으면 더욱 좋습니다.',
    },
    {
        id: 'pm-b2b-2026',
        title: '프로덕트 매니저 (엔터프라이즈)',
        track: '프로덕트·디자인',
        employment: '정규직',
        experience: '경력 5년 이상',
        location: '서울',
        status: '예정',
        postedAt: '2026-05-14',
        summary:
            '고객 요구를 제품 로드맵으로 정리하고, 엔지니어링·디자인과 납기를 조율할 경험자를 상시 검토합니다. 공고 오픈 전 문의도 가능합니다.',
    },
]
